export type TideCalibration = {
    verticalDatum: string; source: 'harmonic-msl'; quality: 'regional-estimate'; qualified: true;
    evidenceId: string; constituentSha256: string; offsetToTerrainM: number;
    chartDatumTerrainM: number; station: string; validFrom: string; validUntil: string;
    minTerrainM: number; maxTerrainM: number;
};
export function qualifiedTideHeight(mslM: number, hash: string, calibration: TideCalibration | null, utcMs: number): number | null {
    if (!calibration || calibration.source !== 'harmonic-msl' || calibration.qualified !== true
        || !/^[a-f0-9]{64}$/.test(hash) || hash !== calibration.constituentSha256
        || !Number.isFinite(mslM) || !Number.isFinite(utcMs) || !Number.isFinite(calibration.offsetToTerrainM)
        || utcMs < Date.parse(calibration.validFrom) || utcMs >= Date.parse(calibration.validUntil)
        || !Number.isFinite(Date.parse(calibration.validFrom)) || !Number.isFinite(Date.parse(calibration.validUntil))) return null;
    const height = mslM + calibration.offsetToTerrainM;
    return height >= calibration.minTerrainM && height <= calibration.maxTerrainM ? height : null;
}
export function validateTideCalibration(value: unknown): TideCalibration | null {
    if (value === null) return null;
    if (!value || typeof value !== 'object') throw new Error('Invalid tide calibration');
    const raw = value as Record<string, unknown>;
    const legacy = Object.hasOwn(raw, 'offsetToOdnM');
    const c = (legacy ? { ...raw, verticalDatum: 'ODN', offsetToTerrainM: raw.offsetToOdnM,
        chartDatumTerrainM: raw.chartDatumOdnM, minTerrainM: raw.minOdnM, maxTerrainM: raw.maxOdnM } : raw) as TideCalibration;
    if (typeof c.verticalDatum !== 'string' || !/^[A-Za-z0-9:_.-]{1,80}$/.test(c.verticalDatum) || c.source !== 'harmonic-msl' || c.quality !== 'regional-estimate' || c.qualified !== true
        || typeof c.evidenceId !== 'string' || !/^[a-z0-9-]{1,80}$/.test(c.evidenceId)
        || typeof c.station !== 'string' || c.station.length > 100
        || !/^[a-f0-9]{64}$/.test(c.constituentSha256) || !Number.isFinite(c.offsetToTerrainM) || Math.abs(c.offsetToTerrainM) > 2
        || !Number.isFinite(c.chartDatumTerrainM) || Math.abs(c.chartDatumTerrainM) > 15
        || !Number.isFinite(c.minTerrainM) || !Number.isFinite(c.maxTerrainM) || c.minTerrainM >= c.maxTerrainM || c.minTerrainM < -15 || c.maxTerrainM > 15
        || !Number.isFinite(Date.parse(c.validFrom)) || !(Date.parse(c.validUntil) > Date.parse(c.validFrom))) throw new Error('Invalid tide calibration');
    return c;
}
